const translations = {
  fr: {
    commonCampaign: {
      campaignOverviewTitle: 'Campagne publicitaire',
      status: 'Statut',
      startsIn: 'Commence dans {{time}}',
      endsIn: 'Termine dans {{time}}',
      notStarted: 'À venir',
      campaignProgression: 'Progression de la campagne',
      campaignProgressionWithValue: 'Progression de la campagne : {{value}}',
      fetchingMetricsErrorTitle: 'Impossible d\'obtenir les données pour cette campagne',
      fetchingMetricsErrorText: 'Aucun spot n\'a encore joué.',
      campaignWillBeginTitle: 'Votre campagne débutera dans {{days}}',
      campaignWillBeginText: 'Aucune donnée n\'est disponible actuellement, car votre campagne n\'a pas encore débuté',
      viewPurchasedCampaigns: 'Voir les campagnes achetées',
      viewProposition: 'Voir la proposition',
      unavailableCampaigns: 'Campagnes indisponibles',
      noCampaigns: 'Aucune campagne',
      noDataAvailabe: 'Les données de cette campagne ne sont pas disponibles',
      all: 'Toutes les campagnes',
      booked: 'À venir',
      completed: 'Terminée',
      running: 'En cours',
      none: 'Aucune',
      cumulative: 'Cumulatif',
      noRightsForCampaignOrNotFound: 'Vous n\'avez pas le droit d\'accéder à cette campagne ou elle n\'existe pas.',
      impressions: 'Impressions',
      estimationTarget: 'Objectif : {{value}}',
      missingAudioFile: 'Aucun fichier audio',
      missingCampaignMessage: 'Aucun message',
      campaignMessageSection: 'Message de campagne',
      audioPlayerSection: 'Message audio',
      dropZoneAudioFile: 'Téléverser',
      editCampaignMessage: 'Modifier le message',
      campaignMessageTextField: 'Message',
      editCampaignMessageButton: 'Modifier',
      addCampaignMessageButton: 'Ajouter',
      deleteAudioFileMessage: 'Desirez-vous retirer le message audio ?',
      shouldHaveCompleted: 'Fin prévue il y a {{time}}',
      errorRemoveAudioFile: 'Problème survenu lors de la suppression du message audio',
      errorUploadingAudioFile: 'Erreur lors du téléversement du fichier audio',
      errorMessageModification: 'Erreur lors de la modification du message',
      toBeCompleted: 'À finaliser',
      completeCampaign: 'Terminer la campagne',
      tooltipCampaingCompleted: 'Vérifier la campagne. Elle peut être finalisée ',
      inProgress: 'En cours',
      sortedBy: 'Ordonné par',
      campaignName: 'Nom de la campagne',
      radio: 'Radio',
      actions: 'Actions',
      startDate: 'Date de début',
      toCreateNewCampaign: 'Créer une nouvelle campagne',
      toSelectAClient: 'Sélectionner un client',
      campaignDate: 'Dates de la campagne',
      campaignTitle: 'Titre de la campagne',
      numberOfSpots: 'Nombre de spots',
      campaignMessage: 'Message de campagne',
      uploadAudioMessage: 'Téléverser le message audio',
      toCreateCampaign: 'Créer une campagne',
      errorCreateCampaign: 'Une erreur est survenue lors de la création',
      succesCreateCampaign: 'La campagne a été créée avec succès',
    },
  },
  en: {
    commonCampaign: {
      campaignOverviewTitle: 'Advertising campaign',
      status: 'Status',
      startsIn: 'Starts in {{time}}',
      endsIn: 'Ends in {{time}}',
      notStarted: 'Upcoming',
      campaignProgression: 'Campaign Progress',
      campaignProgressionWithValue: 'Campaign progress: {{value}}',
      fetchingMetricsErrorTitle: 'Could not fetch the metrics for this campaign',
      fetchingMetricsErrorText: 'No spots have been played yet.',
      campaignWillBeginTitle: 'Your campaign will begin in {{days}}',
      campaignWillBeginText: 'No data is currently available because your campaign has not started yet',
      viewPurchasedCampaigns: 'See purchased campaigns',
      viewProposition: 'View proposal',
      unavailableCampaigns: 'Campaigns unavailable',
      noCampaigns: 'No campaigns',
      noDataAvailabe: 'The metrics for this campaign are not available',
      all: 'All campaigns',
      booked: 'Booked',
      completed: 'Completed',
      running: 'Running',
      none: 'None',
      cumulative: 'Cumulative',
      noRightsForCampaignOrNotFound: 'You can\'t access this campaign or it doesn\'t exist.',
      impressions: 'Impressions',
      estimationTarget: 'Target: {{value}}',
      missingAudioFile: 'No audio file',
      missingCampaignMessage: 'No message',
      campaignMessageSection: 'Campaign message',
      audioPlayerSection: 'Audio message',
      dropZoneAudioFile: 'Upload',
      editCampaignMessage: 'Edit campaign message',
      campaignMessageTextField: 'Campaign message',
      editCampaignMessageButton: 'Edit',
      addCampaignMessageButton: 'Add',
      deleteAudioFileMessage: 'Do you want to remove the audio message ?',
      complete: 'Complete',
      shouldHaveCompleted: 'Planned completion {{time}} ago',
      errorUploadingAudioFile: 'Error uploading audio file',
      errorMessageModification: 'Error while modifying message',
      errorRemoveAudioFile: 'Could not remove audio message',
      toBeCompleted: 'To be finalized',
      completeCampaign: 'Complete campaign',
      tooltipCampaingCompleted: 'This campaign might need to be completed',
      inProgress: 'In progress',
      sortedBy: 'Sorted by',
      campaignName: 'Campaign Name',
      radio: 'Radio',
      actions: 'Actions',
      startDate: 'Start Date',
      toCreateNewCampaign: 'Create a new campaign',
      toSelectAClient: 'Select a client',
      campaignDate: 'Campaign dates',
      campaignTitle: 'Campaign title',
      numberOfSpots: 'Number of spots',
      campaignMessage: 'Campaign message',
      uploadAudioMessage: 'Upload audio message',
      toCreateCampaign: 'Create a campaign',
      errorCreateCampaign: 'An error occured while creating',
      succesCreateCampaign: 'The campaign was created successfully',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/common/modules/campaign/i18n/commonCampaign.js